import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'copilotToolLabel', standalone: false })
export class CopilotToolLabelPipe implements PipeTransform {

  transform(toolName: string | null, input?: any): string {
    if (!toolName) return '';

    const col   = input?.column_name ?? input?.column ?? null;
    const field = input?.field ?? null;
    const cols  = input?.columns ?? null;   // array e.g. scan_sample_ranges

    switch (toolName) {
      case 'dtr_run':
        return 'Running DTR scan';

      case 'run_transformer':
        return input?.config?.runAll ? 'Running full farm' : 'Running sample';

      case 'build_rule':
        return 'Building rules';

      case 'update_description':
        return 'Updating description';

      case 'find_values':
        return col ? `Searching ${col}` : 'Searching columns';

      case 'profile_column':
        return col ? `Profiling ${col}` : 'Profiling column';

      case 'summarize_field':
        return col ? `Summarising ${col}` : 'Summarising field';

      case 'compare_column':
        return col ? `Comparing ${col}` : 'Comparing column';

      case 'analyze_rule_hits':
        return 'Analysing rule hits';

      case 'apply_rules_proposal':
        return 'Building proposal';

      case 'scan_sample_ranges':
        return 'Scanning sample ranges';

      case 'reorder_rules':
        return 'Optimising rule order';

      case 'toggle_rule':
        return field ? `Toggling rule ${field}` : 'Toggling rule';

      case 'add_diagnostic_rule':
        return 'Adding diagnostic rule';

      case 'analyze_existing_config':
        return 'Scoring existing rules';

      default:
        // rate_limit_wait_Xs synthetic tool
        if (toolName.startsWith('rate_limit_wait_')) {
          const secs = toolName.replace('rate_limit_wait_', '').replace('s', '');
          return `Rate limit — waiting ${secs}s`;
        }
        return toolName.replace(/_/g, ' ');
    }
  }
}
